import { format } from "date-fns";
import { Table, TableBody, TableRow, TableCell } from "@mui/material";


const SessionInfoTable = ({ session }) => (
    <Table size="small" sx={{ mb: 1 }}>
        <TableBody>
            <TableRow>
                <TableCell sx={{ color: "text.secondary", border: 0, py: 0.5, px: 0, width: 80 }}>
                    Opened
                </TableCell>
                <TableCell sx={{ border: 0, py: 0.5 }}>
                    {session.openedAt ? format(new Date(session.openedAt), "HH:mm dd/MM/yy") : "-"}
                </TableCell>
            </TableRow>
            {session.status === "closed" && session.closedAt && (
                <TableRow>
                    <TableCell sx={{ color: "text.secondary", border: 0, py: 0.5, px: 0 }}>
                        Closed
                    </TableCell>
                    <TableCell sx={{ border: 0, py: 0.5 }}>
                        {format(new Date(session.closedAt), "HH:mm dd/MM/yy")}
                    </TableCell>
                </TableRow>
            )}
            <TableRow>
                <TableCell sx={{ color: "text.secondary", border: 0, py: 0.5, px: 0 }}>
                    Inventory
                </TableCell>
                <TableCell sx={{ border: 0, py: 0.5 }}>
                    {session.inventory?.length ?? 0} product(s)
                </TableCell>
            </TableRow>
        </TableBody>
    </Table>
);

export default SessionInfoTable;
